// extracted by mini-css-extract-plugin
module.exports = {"commentCompose":"CommentCompose__commentCompose__KnesT"};